import platform from '@24i/nxg-core-utils/src/api/platform';
import { useFeature } from '../../context/AppSettingsData';

export const useArePurchasesEnabled = (): boolean => {
    const inAppPurchases = useFeature('inAppPurchases');
    const stripeSettings = useFeature('stripe');
    const subscriptionsProvider = useFeature('subscriptionsProvider');

    if (!inAppPurchases?.enabled || inAppPurchases?.disabledPlatforms?.includes(platform))
        return false;

    if (stripeSettings && !stripeSettings?.enabled) return false;
    if (subscriptionsProvider && !subscriptionsProvider?.name) return false;

    return true;
};
